import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import { createColumns } from './columns.description'
import InWinOverviewComponent from './component'

export const ChartsOverview = combine(
  withTableController({ id: 'in-win-table' }),
  withContext(
    'adminInWinsService',
    ServicesContext,
    ({ adminInWinsService }) => adminInWinsService
  ),
  withMemo('columns', () => createColumns(), []),
  withCallbacks(
    {
      loadInWins:
        ({ adminInWinsService }) =>
        ({ sorted, page, pageSize }, _table, query = {}) => {
          const serverMapper = {
            id: 'id',
            date: 'date',
            state: 'state',
            'triggerDTO.description': 'trigger_id',
            amount: 'user_amount',
            contributorsAmount: 'contributor_amount',
            triggerDTO: 'event_id',
            'beneficiaryDTO.beneficiaryName': 'beneficiary_id',
          }
          let sortValue = sorted.length === 1 ? sorted[0] : undefined
          if (sortValue) {
            sortValue = `${serverMapper[sortValue.id]},${
              sortValue.desc ? 'asc' : 'desc'
            }`
          }

          return adminInWinsService.queryInWinSearch(query, {
            page: page,
            size: pageSize,
            sort: sortValue,
          })
        },

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(InWinOverviewComponent)
